import { createActions } from 'reduxsauce';
const { Types, Creators } = createActions({
  getListAnnouncement: ['params'],
  getListAnnouncementSuccess: ['announcementList'],
  getListFeature: ['params'],
  getListFeatureSuccess: ['featureList'],
  getTopNews: ['params'],
  getTopNewsSuccess: ['topNewsList'],
  getListMajorOutage: ['params'],
  getListMajorOutageSuccess: ['majorOutageList'],
});
export const ArticleTypes = Types;
export default Creators;
